<template>
    <div>
        <card-header title="Edit Registration Fee" icon="fa-pencil"/>

        <card-body>
            <rmc-fee-form :fee="fee"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteFee"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Fee?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!fee.title || !fee.fee"
                    ><i class="fas fa-check mr-2"></i>Save Fee
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import RmcConferenceForm from "@/cards/RMC/conferences/ConferenceForm";

    import {client as http} from '@/http_client';
    import RmcFeeForm from "./FeeForm";

    export default {
        components: {RmcFeeForm, RmcConferenceForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                fee: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadFee: function() {
                this.$emit('loading', true);
                http.get('rmc/fees/' + this.props.feeId, {force: true}).then(response => {
                    this.fee = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                http.put('rmc/fees/' + this.props.feeId, {
                    id: this.fee.id,
                    title: this.fee.title,
                    fee: this.fee.fee
                }, {force: true}).then(response => {
                    this.$reloadCard('rmc-fees');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the fee.');
                    this.$emit('loading', false);
                });
            },
            deleteFee() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('rmc/fees/' + this.fee.id).then(response => {
                        this.$reloadCard('rmc-fees', {confId: this.props.confId});
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.confId': function() {
                this.dirty = null;
                this.loadFee();
            },
            'fee': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this fee? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadFee();
        }
    };
</script>
